import { render, staticRenderFns } from "./opiniondetails.vue?vue&type=template&id=73335814&scoped=true&"
import script from "./opiniondetails.vue?vue&type=script&lang=js&"
export * from "./opiniondetails.vue?vue&type=script&lang=js&"
import style0 from "./opiniondetails.vue?vue&type=style&index=0&id=73335814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73335814",
  null
  
)

export default component.exports